import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import KloudlessAccountAppResource from "./KloudlessAccountAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";

class KloudlessAccountCalendarPermissionAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'kloudless-account-calendar-permission';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'kloudless/accounts/calendars/permissions';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'kloudlessAccountUuid',
            'calendarId',
            'projectUuid',
            'allProjects',
            'sync',
            'account',
            'project',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            account: KloudlessAccountAppResource,
            project: WorkspaceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            account: 'kloudless_account_uuid',
            project: 'project_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            kloudlessAccountUuid: {
                type: 'string',
            },
            calendarId: {
                type: 'string',
            },
            projectUuid: {
                type: 'string',
            },
            allProjects: {
                type: 'boolean',
            },
            sync: {
                type: 'boolean',
            },
        };
    }
}

export default KloudlessAccountCalendarPermissionAppResource;
